export default __webpack_public_path__ + "static/media/Add_to_Metamask.c69604b4.svg";